// src/lib/api.ts
import { API_BASE } from '../config';

export const apiFetch = (path: string, init: RequestInit = {}) => {
  const base = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
  const url  = `${base}${path.startsWith('/') ? path : `/${path}`}`;

  const headers = new Headers(init.headers);
  const body    = init.body as any;

  let finalInit: RequestInit = { ...init };

  // Decide Content-Type based on body type
  if (body instanceof FormData) {
    // Let the browser set multipart/form-data; boundary=…
    headers.delete('Content-Type');
    // Accept header optional; most endpoints return JSON but don't force it
  } else if (body instanceof URLSearchParams) {
    if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
    }
    if (!headers.has('Accept')) headers.set('Accept', 'application/json');
  } else if (body && typeof body === 'object' && !(body instanceof Blob) && !(body instanceof ArrayBuffer)) {
    // Auto-JSON encode plain objects
    if (!headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
    if (!headers.has('Accept')) headers.set('Accept', 'application/json');
    finalInit = { ...finalInit, body: JSON.stringify(body) };
  } else {
    // Blob/ArrayBuffer/undefined/string — don't force Content-Type
    if (!headers.has('Content-Type')) headers.delete('Content-Type');
    // Keep Accept unset unless caller specified it
  }

  finalInit.headers = headers;
  return fetch(url, finalInit);
};
